import {Component, OnInit} from '@angular/core';
import {EditDataService} from "../services/edit-data.service";
import {Http} from "@angular/http";
/*
import {DataService} from "../services/data.service";
*/

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.scss']
})
export class RulesComponent implements OnInit {
  public data: any = [];

  constructor(private http: Http, public editDataService: EditDataService) {

  }

  ngOnInit() {
    this.editDataService.getData().subscribe(data => this.data = data);
  }

}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/rules/rules.component.ts